import { render, staticRenderFns } from "./DetailedReceipt.vue?vue&type=template&id=4a67381a"
import script from "./DetailedReceipt.vue?vue&type=script&lang=js"
export * from "./DetailedReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports